

;var cwMjs=window.cwMjs || {};

cwMjs.article={

    ajaxAddArticleMood : function($item){
        var request = $.ajax({
            url: '/ajax/news/mood/',
            method: 'post',
            async: 'false',
            dataType: 'json',
            data: {
                id : $item.data('id'),
                mood : $item.data('mood')
            }
        });

        request.done(function(result){
            if(result.code == 200){
                if(result.data.success){
                    var $mood = $item.data('value') + 1;

                    $item.data('value', $mood);
                    $item.find('.count').html($mood);

                    cwMjs.article.moodCount();
                }else{
                    alert(result.data.message);
                }
            }
        });
    },

    moodCount : function(){
        var $items = $('.js-mood-box .mood_item');
        var maxNum = null;
        $items.each(function () {
            var $this = $(this);
            var tmpNum = Number($this.data('value'));
            if (maxNum === null) {
                maxNum = Number($this.data('value'));
            } else {
                if (maxNum < tmpNum) {
                    maxNum = tmpNum;
                }
            }
        });

        if(maxNum===0) return;

        $items.each(function () {
            var $this = $(this);
            var val = Number($this.data('value'));
            var H = Math.ceil(val / maxNum * 100);//100:Max-height of pillar ;
            $this.find('.count').text(val).siblings('.pillar').css({height: 0}).animate({height: H+2}, 600);
        })
    },

    mood: function () {
        var $items = $('.js-mood-box .mood_item');
        console.log(this)
        cwMjs.article.moodCount();

        $.each($items, function(index, item){

            var $item = $(item);
            $item.on('change', '.change_mood', function (e) {
                e.preventDefault();

                if ($items.is('input:checked')) {
                    //alert('您已经表过态了。');
                    return;
                }

                cwMjs.article.ajaxAddArticleMood($item);
                $item.addClass('on');
            });
        });
    },

    commentFlag : false,

    comment : function(){
        var $list = $('.ds-service-list li');
        if($list.length){
            if(!cwMjs.common.isWeiXin()){
                $list.find('.ds-weixin').closest('li').addClass('hide');
            }
            cwMjs.article.commentFlag = true;
        }
    }
};
